import { Button, Checkbox, Col, DatePicker, Flex, Form, Input, InputNumber, Radio, Row, Select, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaCubes, FaSave } from 'react-icons/fa';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import useLocationAPI from '../../apis/locationAPI';
import { RxUpdate } from 'react-icons/rx';
import EventEmitter from '../../../utils/eventEmitter';
import SmartButton from '../../../globalComponents/SmartButton';
import { LuArrowDownUp } from 'react-icons/lu';


const locationTypes = [
  {value: 'internal', label: 'Internal'}, 
  {value: 'customer', label: 'Customer Locations'},
  {value: 'view', label: 'View'},
  {value: 'vendor', label: 'Vendor Location'},
  {value: 'transit', label: 'Transit Location'},
  {value: 'inventory_loss', label: 'Inventory Loss'}
];
const removalOptions = [{value: 'fifo', label: 'First In First Out (FIFO)'}, {value: 'lifo', label: 'Last In First Out (LIFO)'}];



const LocationChanges = () => {
  const {location, warehouses, locations} = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(location.name ? location.name : '');
  const [enableWarehouses, setEnableWarehouses] = useState(false);
  const { create, update } = useLocationAPI();


  const onChangeName = e => setName(e.target.value);
  
  const onChange = value => {
    if (value === 'view') {
      setEnableWarehouses(true);
    }else {
      setEnableWarehouses(false);
    }
  }

  const handleSave = () => { 
    let data = form.getFieldsValue();
    let parentLocName = form.getFieldValue('parent');
    data['name'] = name;
    let seo = name.toLowerCase().replace(/ /g, '-');
    data.seo = seo;
    if (parentLocName) {
      data['seo'] = `${parentLocName.toLowerCase()}-${seo}`;
    }else {
      data.parent_id = null;
    }
    create(data, success);
    // console.log(data)
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    let parentLocName = form.getFieldValue('parent');
    data['name'] = name;
    let seo = name.toLowerCase().replace(/ /g, '-');
    if (parentLocName) {
      data['seo'] = `${parentLocName.toLowerCase()}-${seo}`;
    }else {
      let findParentLoc = locations.find(location => location.id === data.parent_id);
      let parentName = findParentLoc.name.toLowerCase();
      data['seo'] = `${parentName}-${seo}`;
    }
    // console.log(data)
    update(location.seo, data, success);
  };

  useEffect(() => {
    EventEmitter.subscribe('location_response', data => {
      navigate('/inventory/locations/'+data);
    });
    
    return () => EventEmitter.unsubscribe('location_response');
  },[])
  
  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className=''>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/locations'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Locations</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ location.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {location.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
      </div>
      <div className='mt-5 bg-white shadow'>
        {location.seo &&
          <Flex className='border-b m-0' justify='flex-end'>
            <SmartButton icon={<LuArrowDownUp size={'1.4rem'} />} to={`/inventory/locations/${location.seo}/product-moves`} text={'Product Moves'} className='border-s-2' />
            <SmartButton icon={<FaCubes size={'1.4rem'} />} to={`/inventory/locations/${location.seo}/current-stock`} text={'Current Stock'} className='border-s-2' />
          </Flex>
        }
        <Form name="locations"
          form={form}
          labelAlign='left'
          labelCol={{ span: 10 }}
          labelWrap={true}
          initialValues={location.seo ? location : {is_return_location: false}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
          className='p-3'
        >
          <FloatingLabel
            name='name'
            className='text-2xl'
            variant="standard"
            // disabled={formValue.status!== 'discard' ? true : false}
            label="Location Name"
            value={name} 
            onChange={onChangeName}
          />
          <Form.Item labelCol={{span: 3}} label='Parent Location' name="parent_id" className='font-semibold text-gray-800 mb-3' required >
            {!enableWarehouses ? <Select options={locations.map(location=> ({value: location.id, label: location.name}))} onChange={(v, opt) => form.setFieldValue('parent', opt.label)} style={{width: '300px'}} />:
            <Select options={warehouses.map(warehouse=> ({value: warehouse.id, label: warehouse.name}))} style={{width: '300px'}} />}
          </Form.Item>
          <Row className='mt-5'>
            <Col md={{ span: 11 }}>
              <Badge className="text-slate-500 text-lg bg-transparent	border-b-2 mb-3">ADDITIONAL INFORMATION</Badge>
              <Form.Item label='Location Type' name="type" className='font-semibold text-gray-800 mb-3 column' required >
                <Select options={locationTypes} onChange={onChange}/>
              </Form.Item>
              {/* {enableWarehouses && <Form.Item labelCol={{span: 3}} label='Warehouse' name="warehouse_id" className='font-semibold text-gray-800 mb-3 column' required >
                <Select options={warehouses.map(warehouse=> ({value: warehouse.short_name, label: warehouse.name}))} style={{width: '300px'}} />
              </Form.Item>} */}
              <Form.Item label='Is a Return Location' name="is_return_location" className='font-semibold text-gray-800 mb-2 column' required >
                <Checkbox className='border-x-0 border-t-0 input-outline-none font-normal' />
              </Form.Item>
              {/* <Form.Item label='Barcode' name="barcode" className='font-semibold text-gray-800 mb-2 column' required >
                <Input type='text' className='border-x-0 border-t-0 input-outline-none font-normal' />
              </Form.Item> */}
              <Form.Item label='Removal Strategy' name="removal_strategy" className='font-semibold text-gray-800 mb-3 column' required >
                <Select options={removalOptions} />
              </Form.Item>
            </Col>
            <Col md={{span: 10, offset: 1}}>
              <Badge className="text-slate-500 text-lg bg-transparent	border-b-2 mb-3">CYCLIC COUNTING</Badge>
              <Form.Item labelCol={{span: 12}} label='Inventory Frequency (Days)' name='inventory_frequency' className='font-semibold text-gray-800 mb-3 column' required>
                <InputNumber className='border-x-0 border-t-0 input-outline-none font-normal w-full' />
              </Form.Item>
              <Form.Item labelCol={{span: 12}} label='Last Effective Inventory' name='last_effective_inventory' className='font-semibold text-gray-800 mb-3 column' required  >
                <DatePicker className='border-x-0 border-t-0 input-outline-none font-normal w-full' disabled/>
              </Form.Item>
              <Form.Item labelCol={{span: 12}} label='Next Expected Inventory' name='next_expected_inventory' className='font-semibold text-gray-800 mb-3 column' required  >
                <DatePicker className='border-x-0 border-t-0 input-outline-none font-normal w-full' disabled/>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}

export default LocationChanges;